// const API_BASE_URL = process.env.REACT_APP_API_URL || 
//   (process.env.NODE_ENV === 'development' 
//     ? 'http://localhost:5001/api/v1' 
//     : 'https://over-soul-be.onrender.com/api/v1');

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://over-soul-be.onrender.com/api/v1';

class ApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    
    const config = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }

      return data;
    } catch (error) {
      console.error('API request error:', error);
      throw error;
    }
  }

  async joinWaitlist(email) {
    return this.request('/waitlist/join', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }
}

const apiService = new ApiService();
export default apiService;